export default __webpack_public_path__ + "static/media/Facility-Optic-280x215.29612018.jpg";